import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import { Grid } from "@material-ui/core";
import { PaginationContainer } from "./news.styles";
import { NewsGrid } from "./newsGrid.component";
import { INewsPagedRespomse } from "models/response/news-paged-response";
import { PaginationResponse } from "models/pagination-response";
import { useNewsState } from "./context/news-context";
import { useNewsController } from "./context/news-controller";
import { Pagination } from "@material-ui/lab";

type PaginationItemsProps = {
  currentItems: PaginationResponse<INewsPagedRespomse>;
  pageCount: number;
};

const PaginatedItems: React.FC<PaginationItemsProps> = ({ currentItems, pageCount }) => {
  const { news, newsPagedRequest } = useNewsState();

  const { onInit, handleOnChange, listNews } = useNewsController();

  const handlePageClick =(event: React.ChangeEvent<unknown>, value: number) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  
    (async () => {
      await listNews({ ...newsPagedRequest, page: value-1 },true);
    })();
  };

  return (
    <Grid container spacing={7}>
      <Grid item xs={12}>{ }
        <NewsGrid currentItems={currentItems} />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3} justifyContent="center">
        <Pagination size="large" variant="outlined" shape="rounded" onChange={handlePageClick}  count={pageCount} color="primary" />
        </Grid>
      </Grid>
    </Grid>
  );
}
export default PaginatedItems;
